import { IEcole } from './ecole.model';

export interface IVirement {
  montant?: number;
  id?: string;
  description?: string;
  dateEmission?: string;
  statutVirement?: string;
  ecoleId?: string;
  anneeScolaireId?: string;
  compteId?: string;
  ecole?: IEcole | null;
  waveMontant?: number;
  omMontant?: number;
  size?: number;
  page?: number;
}

export const defaultValue: Readonly<IVirement> = {
  montant: 0,
  description: '',
  dateEmission: '',
  statutVirement: null,
  ecoleId: '',
  anneeScolaireId: '',
  compteId: '',
  id: null,
  waveMontant: 0,
  omMontant: 0,
  ecole: null,
  page: 0,
  size: 0,
};
